<tt-page *ngIf="page">
    <tt-card class="col-xs-12 sp-0" [ttHeading]="tabletSize.matches && +(p2WebpageSubscriptionKeyno ?? '0') > 0 ? 'h_webpage_subscription_edit' : undefined" ttTranslateHeading>
        <tt-input ttLabel="p2_webpage_subscription_keyno" [ttModel]="page.p2_webpage_subscription_keyno" ttReadonly></tt-input>
        <tt-input ttLabel="webpage_name_translated" [ttModel]="page.webpage_name_translated" ttReadonly></tt-input>
        <tt-input ttLabel="webpage_name" [(ttModel)]="page.webpage_name"></tt-input>
        <tt-checkbox ttLabel="access" [(ttModel)]="page.access"></tt-checkbox>
        <tt-button-save ttText="save" (ttClick)="saveChanges()" [ttLoading]="saving" ttTextAlign="center"></tt-button-save>
    </tt-card>
</tt-page>
